import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {FormControl, FormControlLabel, FormLabel,} from 'material-ui/Form';
import SimpleCard from './SimpleCard';
import Typography from 'material-ui/Typography';
// import Avatar from 'material-ui/Avatar';
// import playerLogo from '../static/images/child-player.png'
// import staffLogo from '../static/images/man-feeling-action.png'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
    textAlign: 'left',
  },
  option: {
    marginRight: 0,
    marginLeft: -30,
  },
  avatar: {
    // margin: 10,
    display: 'inline-flex',
    height: '0.8em',
    width: '0.8em',
  },
});

const getOption = (options, key) => options.filter(op => op.key === key)[0];

const getInfo = (boardOption) => {
  // key: 'only-registry',
  // key: 'half-board-1',
  // key: 'half-board-2',
  // key: 'full-board-1',
  // key: 'full-board-2',
  const options = {
    'half-board-1':[
      {
        key: 'option-a',
        name: 'Opción A',
        hotels: 'Alte frankfurt, Arco Iris',
        price: 27,
        headline: ''
      },
      {
        key: 'option-b',
        name: 'Opción B',
        hotels: 'Leal La Sirena, La Mariña',
        price: 32,
        headline: ''
      },
      {
        key: 'option-c',
        name: 'Opción C',
        hotels: 'Riamar',
        price: 41,
        headline: ''
      },
    ],
    // 'half-board-meal':[
    //   {
    //     key: 'option-a',
    //     name: 'Opción A',
    //     hotels: 'Alte frankfurt',
    //     price: 36,
    //     headline: ''
    //   },
    //   {
    //     key: 'option-b',
    //     name: 'Opción B',
    //     hotels: 'Leal La Sirena + Dinajan',
    //     price: 43,
    //     headline: ''
    //   },
    //   {
    //     key: 'option-c',
    //     name: 'Opción C',
    //     hotels: 'Arco Iris',
    //     price: 39,
    //     headline: ''
    //   },
    // ],
    'full-board-1':[
      {
        key: 'option-a',
        name: 'Opción A',
        hotels: 'Alte frankfurt, Arco Iris',
        price: 32,
        headline: ''
      },
      {
        key: 'option-b',
        name: 'Opción B',
        hotels: 'Leal La Sirena, La Mariña',
        price: 36,
        headline: ''
      },
      {
        key: 'option-c',
        name: 'Opción C',
        hotels: 'Riamar',
        price: 41,
        headline: ''
      },
      // {
      //   key: 'option-d',
      //   name: 'Opción D (3/4 estrellas)',
      //   hotels: 'Castelao',
      //   price: 68,
      //   headline: ''
      // },
    ],
    'full-board-meal':[
      {
        key: 'option-a',
        name: 'Opción A', 
        hotels: 'Alte frankfurt',
        price: 41,
        headline: ''
      },
      {
        key: 'option-b',
        name: 'Opción B', 
        hotels: 'Arco Iris, Leal La Sirena, La Mariña',
        price: 47,
        headline: ''
      },
      {
        key: 'option-c',
        name: 'Opción C',
        hotels: 'Riamar',
        price: 53,
        headline: ''
      },
      // {
      //   key: 'option-d',
      //   name: 'Opción D (3/4 estrellas)',
      //   hotels: 'Castelao',
      //   price: 68+16,
      //   headline: ''
      // },
    ],
  };
  return options[boardOption];
};


class RadioButtonsGroup extends React.Component {
  constructor(props){
    super(props);
    if (this.props.selectedHotel){
      this.state = {
        value: this.props.selectedHotel.key
      }; 
    }else{
      this.state = {};
    }
  }

  handleChange = (event, value) => {
    const currentOption = getOption(getInfo(this.props.selectedBoarding.key), value);
    this.setState({ value });
    this.props.choiceHandler( currentOption );
  };


  getSelectedValue = info => info[this.state.value]?info[this.state.value]:{
    name: 'Desconocido', 
    price: 68,
    headline: ''
  };

  generateContent = (/*classes*/) => {
    const boardingText = this.props.selectedBoarding.headline;
    const currentInfo = getInfo(this.props.selectedBoarding.key);
    const numberOf = this.props.participants;
    const max = {
      players: 15,
      staff: 2,
    };
    const min = {
      players: 7,
      staff: 1,
    };
    const players = numberOf.players > max.players ? max.players : numberOf.players < min.players ? min.players : numberOf.players;
    const staff = numberOf.staff > max.staff ? max.staff : numberOf.staff < min.staff ? min.staff : numberOf.staff;
    // const playerIcon = <Avatar alt="Player" src={playerLogo} className={classes.avatar} />;
    // const staffIcon = <Avatar alt="Staff" src={staffLogo} className={classes.avatar} />;
    // const playerIcon = <img alt="Player" src={playerLogo} className={classes.avatar} />;
    // const staffIcon = <img alt="Staff" src={staffLogo} className={classes.avatar} />;
    const playerIcon = 'J' ;
    const staffIcon = 'CT' ;

    if (this.state.hasOwnProperty('value') && (this.state.value !== undefined) && getOption(currentInfo, this.state.value)){
      const optionSelected = getOption(currentInfo, this.state.value);
      const unitPrice = optionSelected.price;
      return <div style={{textAlign: 'left'}}>
        <Typography type="body1">- {boardingText} <br/>- {optionSelected.name} <br/> <br/>
          Inscripción: 100€<br/>
          Estancia: {unitPrice}€ x ({players} {playerIcon} + {staff} {staffIcon})
          = {(players + staff) * unitPrice}€ <br/>
          <strong>Total: {100 + (players + staff) * unitPrice} € (IVA incluido)</strong>
          <br/> <br/>En el siguiente paso se mostrarán todas las opciones elegidas para que puedas confirmarlas
        </Typography>
      </div>;
  
    }else{
      return <Typography type="body1">
        Podremos decirte el precio estimado para {boardingText} cuando selecciones una opción
      </Typography>;
  }

  };

  render() {
    const { classes } = this.props;
    const info = getInfo(this.props.selectedBoarding.key);
    // const renderableOptions = Object.entries(info)
    // .map(([key, value]) => ({...value, key: key}));
    const renderOptions = info
    .map((data/*, idx*/) => {
      if (data.key !== 'default') {
        return <FormControlLabel key={data.key} value={data.key} control={<Radio />} label={`${data.name} - ${data.price} €/persona`} className={classes.option}/>
      }
      return '';
    });

    return (
        <div>
      <div className={classes.root}>
        <FormControl component="fieldset" required className={classes.formControl}>
          <FormLabel component="legend">Precio estimado</FormLabel>
          <RadioGroup
            aria-label="registryOptions"
            name="registryOptions1"
            className={classes.group}
            value={this.state.value}
            onChange={this.handleChange}
          >
          {renderOptions}
          </RadioGroup>
        </FormControl>
      </div>
      <SimpleCard title="Precio estimado"
      headline={this.getSelectedValue(info).headline}
      content={this.generateContent(classes)}/>       
       </div>
    );
  }
}

RadioButtonsGroup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RadioButtonsGroup);


// WEBPACK FOOTER //
// ./src/components/ChooseHotels.jsx